export * from './payrollDataUpload.component';



// WEBPACK FOOTER //
// ./src/app/PayrollDataUpload/index.ts